package com.merkost.handpass.api.dto.admin

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class BanPreviewResponse(
    @SerialName("active_listings") val activeListings: Long,
    @SerialName("pending_offers") val pendingOffers: Long,
    @SerialName("conversations") val conversations: Long,
)
